// Song data for the songlist
// Complete song catalog with metadata

import { Song } from '../types';

// Featured songs order for video player - songs appear in this order, rest are sorted alphabetically
export const featuredSongsOrder: string[] = [
  "Prehistoric Dog",
  "Baby One More Time"
];

export const songData: Song[] = [
  {
    id: 1,
    title: "War Pigs",
    artist: "Black Sabbath",
    genre: "Classic Metal",
    year: 1970
  },
  {
    id: 2,
    title: "Enter Sandman",
    artist: "Metallica",
    genre: "Metal",
    year: 1991
  },
  {
    id: 3,
    title: "Baby One More Time",
    artist: "Bowling for Soup",
    genre: "Pop",
    year: 2004,
    videoUrl: "https://www.youtube.com/watch?v=yiQwwq5xm5Y"
  },
  {
    id: 4,
    title: "Creep",
    artist: "Radiohead",
    genre: "Rock",
    year: 1992
  },
  {
    id: 5,
    title: "Hash Pipe",
    artist: "Weezer",
    genre: "Rock",
    year: 2001
  },
  {
    id: 6,
    title: "Cold Hard Bitch",
    artist: "JET",
    genre: "Rock",
    year: 2003
  },
  {
    id: 7,
    title: "The Pot",
    artist: "Tool",
    genre: "Metal",
    year: 2006
  },
  {
    id: 8,
    title: "Wires",
    artist: "Red Fang",
    genre: "Metal",
    year: 2011
  },
  {
    id: 9,
    title: "Ace of Spades",
    artist: "Motörhead",
    genre: "Classic Metal",
    year: 1980,
    videoUrl: "MZLRVu02aGU"
  },
  {
    id: 10,
    title: "Give It All",
    artist: "Rise Against",
    genre: "Rock",
    year: 2004
  },
  {
    id: 11,
    title: "Detroit Rock City",
    artist: "KISS",
    genre: "Classic Rock",
    year: 1976,
    videoUrl: "https://www.youtube.com/watch?v=atF0DOE9lKs"
  },
  {
    id: 12,
    title: "Square Hammer",
    artist: "Ghost",
    genre: "Metal",
    year: 2016
  },
  {
    id: 13,
    title: "Cumbersome",
    artist: "Seven Mary Three",
    genre: "Rock",
    year: 1995,
    videoUrl: "https://www.youtube.com/watch?v=v4uk2sQVbbI"
  },
  {
    id: 14,
    title: "Like a Stone",
    artist: "Audioslave",
    genre: "Rock",
    year: 2002
  },
  {
    id: 15,
    title: "Drive",
    artist: "Incubus",
    genre: "Rock",
    year: 2001,
    videoUrl: "https://www.youtube.com/watch?v=PCIKvbc4kCQ"
  },
  {
    id: 16,
    title: "Outside",
    artist: "Staind",
    genre: "Rock",
    year: 2001},
  {
    id: 17,
    title: "Face Down",
    artist: "The Red Jumpsuit Apparatus",
    genre: "Rock",
    year: 2006
  },
  {
    id: 18,
    title: "Pain",
    artist: "Jimmy Eat World",
    genre: "Rock",
    year: 2004,
    videoUrl: "https://www.youtube.com/watch?v=DgbEzu8VFkU"
  },
  {
    id: 19,
    title: "Sweet Mountain River",
    artist: "Monster Truck",
    genre: "Rock",
    year: 2012
  },
  {
    id: 20,
    title: "They Say",
    artist: "Scars on Broadway",
    genre: "Rock",
    year: 2008
  },
  {
    id: 21,
    title: "Crazy Train",
    artist: "Ozzy Osbourne",
    genre: "Classic Metal",
    year: 1980
  },
  {
    id: 22,
    title: "Holy Diver",
    artist: "Dio",
    genre: "Classic Metal",
    year: 1983
  },
  {
    id: 23,
    title: "Prehistoric Dog",
    artist: "Red Fang",
    genre: "Metal",
    year: 2009,
    videoUrl: "https://www.youtube.com/watch?v=_i6sG8vViMc"
  },
  {
    id: 24,
    title: "Flagpole Sitta",
    artist: "Harvey Danger",
    genre: "Rock",
    year: 1997
  },
  {
    id: 25,
    title: "All the Small Things",
    artist: "Blink-182",
    genre: "Pop",
    year: 1999
  },
  {
    id: 26,
    title: "Sabotage",
    artist: "FIDLAR",
    genre: "Rock",
    year: 2015
  },
  {
    id: 27,
    title: "Mother",
    artist: "Danzig",
    genre: "Classic Metal",
    year: 1988
  },
  {
    id: 28,
    title: "Paranoid",
    artist: "Black Sabbath",
    genre: "Classic Metal",
    year: 1970,
    videoUrl: "https://www.youtube.com/watch?v=lXhrKxExmOs"
  },
  {
    id: 29,
    title: "Girl All the Bad Guys Want",
    artist: "Bowling for Soup",
    genre: "Pop",
    year: 2002
  },
  {
    id: 30,
    title: "Bleed American",
    artist: "Jimmy Eat World",
    genre: "Rock",
    year: 2001,
    videoUrl: "https://www.youtube.com/watch?v=ZB--iHGRORk"
  }
];
